import axios from 'axios';

import config from '@/utility/config';
import { addQueryParamsToPath } from '@/utility/routesHelper';

import { getAxiosErrorMsg } from '../helpers';
import adminProtectedAxiosRequest from '../helpers/adminProtectedAxiosRequest';

const {
  communityApiBasePath,
  connectTelegramLink,
  telegramBackEndApiKey
} = config;

export const getWhatsappAnalyticsData = async (payload) => {
  try {
    const { communityId, duration } = payload;
    const path = `${communityApiBasePath}/api/v1/whatsapp-analytics/${communityId}?duration=${duration}`;
    const res = await adminProtectedAxiosRequest.get(path);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getHomeAnalyticsData = async (payload) => {
  try {
    const { communityId, duration } = payload;
    const path = `${communityApiBasePath}/api/v1/cmp-home/${communityId}/analytics?duration=${duration}`;
    const res = await adminProtectedAxiosRequest.get(path);

    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getRevenuesData = async (payload) => {
  try {
    const { communityId, duration } = payload;
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/transactions/revenues?duration=${duration}`;
    const res = await adminProtectedAxiosRequest.get(path);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getAnalyticsData = async (payload) => {
  try {
    const { communityId } = payload;
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/analytics`;
    const res = await adminProtectedAxiosRequest.get(path);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getChatAnalyticsData = async (payload) => {
  try {
    const { botType, startDate, endDate, group_id } = payload;
    const path = `${communityApiBasePath}/api/v1/bot-stats?user_type=${botType}&startDate=${startDate}&endDate=${endDate}&group_id=${group_id}`;
    const res = await adminProtectedAxiosRequest.get(path);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getMemberChartsData = async (payload) => {
  try {
    const { communityId, duration } = payload;
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/analytics-graph?days=${duration}`;
    const res = await adminProtectedAxiosRequest.get(path);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const postChatPlatformServerKey = async (data) => {
  const { communityId, payload } = data;
  const path = `${communityApiBasePath}/api/v1/communities/${communityId}/social-bot-integration`;
  const { data: responseData, error } =
    await adminProtectedAxiosRequest.post(path, payload);

  if (error) {
    return { data: null, error: getAxiosErrorMsg(error) };
  }

  return { data: responseData, error: null };
};

export const postTelegramInformationToUser = async (data) => {
  try {
    const path = `${connectTelegramLink}/api/v1/telegram/add-group`;

    const res = await axios.post(path, data, {
      headers: {
        'Content-Type': 'application/json',
        'api-key': telegramBackEndApiKey
      }
    });
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getTrafficData = async (payload) => {
  try {
    const { communityId, ...params } = payload;

    let path = `${communityApiBasePath}/api/v1/communities/${communityId}/analyticsV2`;
    const pathWithParams = addQueryParamsToPath(path, params);
    const res = await adminProtectedAxiosRequest.get(pathWithParams);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getCommunityVisits = async (payload) => {
  try {
    const { communityId, ...params } = payload;

    let path = `${communityApiBasePath}/api/v1/communities/${communityId}/analyticsV2/monthly-overview`;
    const pathWithParams = addQueryParamsToPath(path, params);
    const res = await adminProtectedAxiosRequest.get(pathWithParams);
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};
